
import WalletMoney from "../../../assets/duotone/WalletMoney.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WalletMoneyIcon({ className, dataTestid = "WalletMoneyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <WalletMoney data-testid={dataTestid} className={classes} {...rest} />
  );
}
